import { gql } from "@apollo/client";

export const SOLICITAR_AUTORIZACION = gql`
    mutation solicitarAutorizacion(
        $idEvaluacion: Int!,
        $observacion: String!,
        $precio: Decimal!
    ){
        solicitarAutorizacion(
            input: {
                idEvaluacion: $idEvaluacion,
                observacion: $observacion,
                precio: $precio
            }
        ) {
            idEvaluacion
        }
    }
`;